import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { Inline } from '@atlaskit/primitives/compiled';
import { messages } from '../../../../../index';
import { extractIssueKey } from '../../utils';
var JiraReplyBar = function JiraReplyBar(_ref) {
  var contentLink = _ref.contentLink,
    cloudId = _ref.cloudId,
    commentId = _ref.commentId,
    isEditorShown = _ref.isEditorShown,
    onCommentEditorShown = _ref.onCommentEditorShown,
    threadParentId = _ref.threadParentId,
    issueAri = _ref.issueAri,
    _ref$projectId = _ref.projectId,
    projectId = _ref$projectId === void 0 ? '' : _ref$projectId,
    _ref$projectType = _ref.projectType,
    projectType = _ref$projectType === void 0 ? '' : _ref$projectType;
  var issueKey = extractIssueKey(contentLink);

  // Early return if no issueKey
  if (!issueKey) {
    return null;
  }
  var showEditor = function showEditor() {
    var replyCommentParentId = threadParentId;
    onCommentEditorShown(replyCommentParentId, issueAri, projectId, projectType);
  };
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between",
    testId: "jira-reply-bar"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, !isEditorShown && /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    spacing: "compact",
    onClick: showEditor,
    testId: "jira-reply-button"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.reply))));
};
export default JiraReplyBar;